import axiosInstance from '../../../config/axiosInstance';
const StockBatchService = {
    async GetAllStockBatches(redirectCallback, StockID,StockLocationID=0) {
        try {
            const response = await axiosInstance.get(`/Part/GetPartBatches?PartID=${StockID}&StockLocationID=${StockLocationID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllStockBatchLocations(redirectCallback, StockID) {
        try {
            const response = await axiosInstance.get(`/Part/GetPartBatchLocation?PartID=${StockID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetBatchStatuses(BatchID) {
        try {
            const response = await axiosInstance.get(`/Part/GetBatchStatuses?BatchID=${BatchID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllNewStockBatches(redirectCallback, StockID,StockLocationID=0,Start, PageSize, searchQuery, sortColumn, sortDirection) {
        try {
            const response = await axiosInstance.get(`/Part/GetAllNewStockBatches?PartID=${StockID}&StockLocationID=${StockLocationID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetStockBatchesCount(redirectCallback, StockID,StockLocationID=0, searchQuery) {
        try {
            const response = await axiosInstance.get(`/Part/GetStockBatchesCount?PartID=${StockID}&StockLocationID=${StockLocationID}&searchQuery=${searchQuery}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
};

export default StockBatchService;